type RozeniteNativeDevtoolsDispatcher = {
  BINDING_NAME?: unknown;
  initializeDomain?: unknown;
  onDomainInitialization?: unknown;
};

declare global {
  var __FUSEBOX_REACT_DEVTOOLS_DISPATCHER__: RozeniteNativeDevtoolsDispatcher | undefined;
}

export function isRozeniteNativeDevtoolsAvailable() {
  const dispatcher = globalThis.__FUSEBOX_REACT_DEVTOOLS_DISPATCHER__;

  return (
    typeof dispatcher?.BINDING_NAME === "string" &&
    typeof dispatcher.initializeDomain === "function" &&
    dispatcher.onDomainInitialization !== undefined
  );
}
